import { viewDocumentsTab, viewMessagesTab, viewBusiness, call, snoozeFiveMin, snoozeOneHour, markAsCompleted, dismissCall, startCall } from './notification-actions';
import { NotificationConfig } from './notification.model';

export const notifications: NotificationConfig[] = [
  {
    type: 'note',
    icon: 'notes',
    heading: 'New Note',
    dismissible: true,
    color: 'app'
  },
  {
    type: 'document',
    icon: 'upload_file',
    heading: 'Document Uploaded',
    dismissible: true,
    color: 'app',
    actions: [
      viewDocumentsTab
    ]
  },
  {
    type: 'bp_upload_document',
    icon: 'upload_file',
    heading: 'Document Uploaded',
    dismissible: true,
    color: 'app',
    actions: [
      viewDocumentsTab
    ]
  },
  {
    type: 'assignment',
    icon: 'person_add',
    heading: 'New Assignment',
    dismissible: true,
    color: 'app',
    navigationRoute: '/today'
  },
  {
    type: 'bulkAssignment',
    icon: 'person_add',
    heading: 'New Assignment',
    color: 'app',
    dismissible: true,
    hideDismissButton: true,
    dismissDelay: 15000,
    navigationRoute: '/today'
  },
  {
    type: 'shared',
    icon: 'business',
    heading: 'New Shared Business',
    dismissible: true,
    color: 'app',
    actions: [
      viewBusiness
    ]
  },
  {
    type: 'unshared',
    icon: 'remove_circle_outline',
    heading: 'Sharing Removed',
    dismissible: true,
    color: 'app'
  },
  {
    type: 'deal',
    icon: 'notifications_active',
    heading: 'Deal Funded!',
    dismissible: true,
    color: 'app'
  },
  {
    type: 'dealApprovedPackaging',
    icon: 'notifications_active',
    heading: 'Deal Approved for Packaging',
    dismissible: true,
    color: 'app'
  },
  {
    type: 'offerBorrowerAccepted',
    icon: 'thumb_up',
    heading: 'Offer Accepted',
    dismissible: true,
    color: 'app'
  },
  {
    type: 'offerBorrowerDeclined',
    icon: 'thumb_down',
    heading: 'Offer Declined',
    dismissible: true,
    color: 'app'
  },
  {
    type: 'offerCreated',
    icon: 'approval',
    heading: 'Offer Received',
    dismissible: true,
    color: 'app',
    actions: [
      viewBusiness
    ]
  },
  {
    type: 'comment',
    icon: 'notes',
    heading: 'New Comment',
    dismissible: true,
    color: 'comm'
  },
  {
    type: 'callReminder',
    icon: 'alarm',
    heading: 'Call Back Reminder',
    dismissible: false,
    color: 'comm',
    actions: [
      call,
      snoozeFiveMin,
      snoozeOneHour,
      markAsCompleted
    ]
  },
  {
    type: 'messageReminder',
    icon: 'alarm',
    heading: 'Message Reminder',
    dismissible: false,
    color: 'comm',
    actions: [
      viewMessagesTab,
      snoozeFiveMin,
      snoozeOneHour,
      markAsCompleted
    ]
  },
  {
    type: 'todoReminder',
    icon: 'alarm',
    heading: 'To Do Reminder',
    dismissible: false,
    color: 'comm',
    actions: [
      viewBusiness,
      snoozeFiveMin,
      snoozeOneHour,
      markAsCompleted
    ]
  },
  {
    type: 'reminder',
    icon: 'alarm',
    heading: 'Reminder',
    dismissible: false,
    color: 'comm',
    actions: [
      viewBusiness,
      snoozeFiveMin,
      snoozeOneHour,
      markAsCompleted
    ]
  },
  {
    type: 'progress',
    icon: 'change_circle',
    heading: 'Status Change',
    dismissible: true,
    color: 'app'
  },
  {
    type: 'sms',
    icon: 'chat',
    dismissible: true,
    color: 'comm',
    actions: [
      viewBusiness,
      viewMessagesTab
    ]
  },
  {
    type: 'message',
    icon: 'email',
    dismissible: true,
    color: 'comm',
    actions: [
      viewBusiness,
      viewMessagesTab
    ]
  },
  {
    type: 'approval',
    icon: 'approval',
    dismissible: true,
    color: 'app',
    actions: [
      viewBusiness
    ]
  },
  {
    type: 'undeliveredMessage',
    heading: 'Undeliverable Email Message',
    icon: 'error',
    dismissible: true,
    color: 'comm'
  },
  {
    type: 'openedMessage',
    heading: 'Email Message Read',
    icon: 'mark_email_unread',
    dismissible: true,
    color: 'comm',
    actions: [
      viewBusiness,
      call
    ]
  },
  {
    type: 'phone',
    icon: 'ring_volume',
    heading: 'Incoming Call',
    dismissible: false,
    color: 'comm',
    actions: [
      dismissCall,
      startCall
    ],
  },
  {
    type: 'missedCall',
    icon: 'ring_volume',
    heading: 'Missed Call',
    dismissible: true,
    color: 'comm',
    actions: [
      viewBusiness
    ],
  },
  {
    type: 'callQueue',
    icon: 'ring_volume',
    heading: 'Incoming Queue Call',
    dismissible: true,
    color: 'comm',
    dismissDelay: 10000,
    actions: [
      dismissCall,
      startCall
    ],
  },
  {
    type: 'lenderUserCallQueue',
    icon: 'ring_volume',
    heading: 'Cannot Add Borrower to Queue',
    dismissible: true,
    color: 'comm',
    dismissDelay: 10000
  },
  {
    type: 'borrowerLoggedWithOptions',
    icon: 'visibility',
    dismissible: true,
    color: 'app',
    actions: [
      viewBusiness,
      call
    ]
  },
];
